import Reveal from '../../../shared/Reveal/Reveal';
import { useInfrastructureOperationalContent } from '../../../../hooks/useInfrastructureOperationalContent';
import './Operational.css';

const Operational = () => {
  const { content, isLoading } = useInfrastructureOperationalContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, items } = content;

  return (
    <section className="infrastructure-operational">
      <div className="infrastructure-operational__inner">
        <Reveal>
          <h2 className="infrastructure-operational__title">{title}</h2>
        </Reveal>

        <div className="infrastructure-operational__grid">
          {items.map(({ title: itemTitle, text, icon }, index) => (
            <Reveal key={itemTitle} delay={index * 70}>
              <article className="infrastructure-operational__item">
                {icon ? (
                  <div className="infrastructure-operational__icon-wrap">
                    <img
                      className="infrastructure-operational__icon"
                      src={icon}
                      alt=""
                      aria-hidden="true"
                    />
                  </div>
                ) : null}
                <h3 className="infrastructure-operational__item-title">{itemTitle}</h3>
                <p className="infrastructure-operational__item-text">{text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Operational;
